import { PHONE_DISPLAY, PHONE_TEL } from '../../../lib/businessInfo';

export function FinalCta() {
  return (
    <section className="bg-gradient-to-br from-teal-500 to-teal-600 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Ready to Find Your Perfect Vehicle?
        </h2>
        <p className="text-xl text-teal-50 mb-8 max-w-2xl mx-auto">
          Browse our inventory online or give us a call. We're here to help you find the right car at the right price.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="/inventory"
            className="inline-flex items-center px-8 py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-teal-50 transition-colors"
          >
            View All Vehicles
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href={`tel:${PHONE_TEL}`}
            className="inline-flex items-center px-8 py-4 bg-teal-700 text-white font-semibold rounded-lg hover:bg-teal-800 transition-colors"
          >
            <i className="ri-phone-line mr-2"></i>
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
}

export default FinalCta;
